import { render, staticRenderFns } from "./pdentry.vue?vue&type=template&id=5cc49ea5&scoped=true&"
import script from "./pdentry.vue?vue&type=script&lang=js&"
export * from "./pdentry.vue?vue&type=script&lang=js&"
import style0 from "./pdentry.vue?vue&type=style&index=0&id=5cc49ea5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc49ea5",
  null
  
)

export default component.exports